export * from "./babylonFileLoader.js";
//# sourceMappingURL=index.js.map